import {
  dtlDifferenceList,
  getListBudgetDtl,
  listProductSkuRelationSpuFormat,
  updatePackDtl,
} from '@/services/order'
import { Button, Divider, Tooltip } from 'antd'
import { isArray } from 'lodash-es'
import { SDrawerOrModal, SLowcodeList, SSkuCard } from 'shj-components'
import { useFileUrlPrefix } from 'shj-utils'
import styles from '../../index.module.less'
import { useEffect, useRef, useState } from 'react'
import KitDetailDialogV3 from '../KitDetailDialogV3'
import { productSkuDetail } from '@/services/product'
import { useSetState } from 'ahooks'
import ProductDetailDrawer from '@/components/ProductDetailDrawer'
export default function DifferentiationList(props: any) {
  const { open, onClose, budgetId } = props
  const fileUrlPrefix = useFileUrlPrefix()
  // 套件选择
  const [kitSku, setKitSku] = useState<any>({})
  const [kitSpu, setKitSpu] = useState<any>({})
  const [openKitDialog, setOpenKitDialog] = useState(false)
  const [combinationInfoList, setCombinationInfoList] = useState<any[]>([])
  const [packDtlList, setPackDtlList] = useState<any[]>([])
  const [activityInfo, setActivityInfo] = useState<any>({})
  const [recordItem, setRecordItem] = useState<any>(null) //当前子数据
  const [recordInfo, setRecordInfo] = useState<any>(null) // 当前数据
  const listRef = useRef<any>(null)
  const [previewObj, setPreviewObj] = useSetState<any>({
    open: false,
    loading: false,
    descType: [],
    data: {},
  })
  console.log('测试')

  const config = {
    tableType: 'antd',
    rowSelection: false,
    columns: [
      {
        title: '空间',
        dataIndex: 'spaceName',
        width: 120,
        ellipsis: {
          showTitle: false,
        },
        render: (text: any, record: any) => {
          return (
            <Tooltip title={text} placement="topLeft" autoAdjustOverflow>
              {text}
            </Tooltip>
          )
        },
      },
      {
        title: '通项/分类',
        dataIndex: 'quoteBudgetDtlGeneralVoList',
        width: 100,
        render: (text: any, record: any) => {
          return nodeRender(text, record, 'quoteBudgetDtlGeneralVoList', 'name')
        },
        // onCell: (record, index) => {
        //   console.log(record, record,333333);
        //   return {}
        // },
      },
      {
        title: '原产品信息',
        dataIndex: 'oldBudgetDtlVoList',
        children: [
          {
            title: '产品',
            dataIndex: 'product',
            width: 300,
            render: (text: any, record: any) => {
              return nodeRender(text, record, 'oldBudgetDtlVoList', 'renderSku')
            },
          },
          {
            title: '单价/单位',
            dataIndex: 'price/unit',
            width: 100,
            render: (text: any, record: any) => {
              return nodeRender(text, record, 'oldBudgetDtlVoList', 'price/unit')
            },
          },
          {
            title: '预算量',
            dataIndex: 'displayQtyValue',
            width: 100,
            render: (text: any, record: any) => {
              return nodeRender(text, record, 'oldBudgetDtlVoList', 'displayQtyValue')
            },
          },
          {
            title: '规格',
            dataIndex: 'dynaOptions',
            width: 150,
            render: (text: any, record: any) => {
              return nodeRender(text, record, 'oldBudgetDtlVoList', 'dynaOptions')
            },
          },
          {
            title: '备注',
            dataIndex: 'remark',
            width: 120,
            render: (text: any, record: any) => {
              return nodeRender(text, record, 'oldBudgetDtlVoList', 'remark')
            },
          },
        ],
      },
      {
        title: '新产品信息',
        dataIndex: 'budgetDtlVoList',
        children: [
          {
            title: '产品',
            dataIndex: 'product',
            width: 300,
            render: (text: any, record: any) => {
              return nodeRender(text, record, 'budgetDtlVoList', 'renderSku')
            },
          },
          {
            title: '单价/单位',
            dataIndex: 'price/unit',
            width: 100,
            render: (text: any, record: any) => {
              return nodeRender(text, record, 'budgetDtlVoList', 'price/unit')
            },
          },
          {
            title: '预算量',
            dataIndex: 'displayQtyValue',
            width: 100,
            render: (text: any, record: any) => {
              return nodeRender(text, record, 'budgetDtlVoList', 'displayQtyValue')
            },
          },
          {
            title: '规格',
            dataIndex: 'dynaOptions',
            width: 120,
            render: (text: any, record: any) => {
              return nodeRender(text, record, 'budgetDtlVoList', 'dynaOptions')
            },
          },
          {
            title: '备注',
            dataIndex: 'remark',
            width: 120,
            render: (text: any, record: any) => {
              return nodeRender(text, record, 'budgetDtlVoList', 'remark')
            },
          },
        ],
      },
    ],
    search: [],
    scroll: {
      x: 700,
    },
  }

  const nodeRender = (text, record, dataIndex, currentDataIndex?) => {
    if (!record?.quoteBudgetDtlGeneralVoList?.length) return
    return (
      <>
        {record?.quoteBudgetDtlGeneralVoList?.map((item, index) => {
          console.log(item, '111111111111111')

          let list = item?.[dataIndex]
          if (isArray(list) && ['oldBudgetDtlVoList', 'budgetDtlVoList'].includes(dataIndex)) {
            return list.map((el, elIndex) => {
              let showText: any = el?.[currentDataIndex]
              if (currentDataIndex === 'renderSku') {
                return (
                  <>
                    {(elIndex != 0 || index !== 0) && (
                      <Divider
                        style={{
                          margin: '4px 0',
                          borderBlockStart: '1px dashed rgba(5, 5, 5, 0.06)',
                        }}
                      />
                    )}
                    {
                      <SSkuCard
                        key={elIndex + '-' + record?.id + '-' + el?.id + '-' + el.prdSkuId}
                        width={'100%'}
                        url={
                          el?.mainPic
                            ? el.mainPic.startsWith('http')
                              ? el.mainPic
                              : fileUrlPrefix + el.mainPic
                            : 'https://static.shjmall.cn/sass/empty.png'
                        }
                        urlList={el?.imageUrls}
                        title={
                          <div
                            style={{
                              width: '100%',
                            }}
                            className={styles.skuTitle}
                          >
                            {/* {showNationalTagRender(el)}*/}
                            <Tooltip title={el.name} placement="topLeft" autoAdjustOverflow>
                              <a
                                style={{ fontSize: '12px', fontWeight: '400' }}
                                onClick={() => onOpenProductDetail(el.prdSkuId)}
                              >
                                {el.name}
                              </a>
                            </Tooltip>
                          </div>
                        }
                        imgFit={false}
                        desc={<span className={styles.skuDesc}>SKU: {el.prdSkuId}</span>}
                        imgFilter={
                          el?.skuWarnMessage ? (
                            <div dangerouslySetInnerHTML={{ __html: el?.skuWarnMessage }} />
                          ) : undefined
                        }
                        disabled={el?.skuWarnMessage}
                        operation={() => {
                          return (
                            <>
                              {
                                <>
                                  {el.refType !== 'SUB' &&
                                    !el.refDeductId &&
                                    el.packDtlList &&
                                    !!el.packDtlList.length && (
                                      <Button
                                        size="small"
                                        type="primary"
                                        ghost
                                        onClick={() => handleKitDetail(record, el)}
                                      >
                                        产品明细
                                      </Button>
                                    )}
                                </>
                              }
                            </>
                          )
                        }}
                      />
                    }
                  </>
                )
              }
              if (currentDataIndex === 'dynaOptions') {
                if (showText && Object.keys(showText).length) {
                  const strings: string[] = []
                  for (let key in showText) {
                    strings.push(`${showText[key].argName}：${showText[key].valueName}`)
                  }
                  showText = strings.map((str: string) => str)
                } else {
                  showText = ''
                }
              }
              if (currentDataIndex === 'price/unit') {
                showText = el.saleCustPrice + '/' + el.prdUnit
              }

              return (
                <>
                  {elIndex != 0 && (
                    <Divider
                      style={{
                        margin: '4px 0',
                        borderBlockStart: '1px dashed rgba(5, 5, 5, 0.06)',
                      }}
                    />
                  )}
                  <div
                    style={{
                      minHeight: '70px',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    <Tooltip
                      autoAdjustOverflow
                      title={showText}
                      placement={currentDataIndex !== 'remark' ? 'topLeft' : 'top'}
                    >
                      {showText}
                    </Tooltip>
                  </div>
                </>
              )
            })
          }
          if (currentDataIndex === 'name') {
            // 渲染通项 高度等于原产品数据的长度
            let list = item?.oldBudgetDtlVoList
            let height = 79 * list.length
            if (isArray(list) && list.length) {
              return list.map((el: any, elIndex: number) => {
                return (
                  <>
                    {elIndex === 0 && (
                      <div
                        style={{
                          minHeight: height + 'px',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Tooltip
                          autoAdjustOverflow
                          title={item?.[currentDataIndex]}
                          placement={currentDataIndex !== 'remark' ? 'topLeft' : 'top'}
                        >
                          {item?.[currentDataIndex]}
                        </Tooltip>
                      </div>
                    )}
                  </>
                )
              })
            }
          }
          return (
            <>
              <Tooltip title={item?.[currentDataIndex]} placement="topLeft">
                <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {item?.[currentDataIndex]}
                </div>
              </Tooltip>
            </>
          )
        })}
      </>
    )
  }
  const onOpenProductDetail = productId => {
    setPreviewObj({ open: true, loading: true })
    productSkuDetail(productId)
      .then(res => {
        setPreviewObj({
          data: res,
        })
      })
      .finally(() => setPreviewObj({ loading: false }))
  }
  const fetchList = async () => {
    let resData = await dtlDifferenceList({
      params: {
        quoteBudgetId: budgetId,
      },
    })
    resData = resData.map((item: any, index) => {
      return {
        ...item,
        orderSeq: index + 1,
      }
    })
    listRef.current?.updateDataSource([...resData])
  }
  const extension = {
    request: {
      fetchList,
    },
    pagination: false,
  }
  /**
   * 产品明细功能函数
   * @name handleKitDetail  点击处理产品明细
   * @name closeKitDialog  关闭弹窗
   * @name confirmInfo  确认产品明细
   */

  // 套件
  const handleKitDetail = async (record: any, item) => {
    setOpenKitDialog(true)
    setRecordItem(item)
    setRecordInfo(record)
    setKitSku({})
    setKitSpu({})
    try {
      let resData: any = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          budgetDtlId: item.id,
          productSkuId: item.prdSkuId,
          productSpuId: item.prdId,
        },
      })
      let skuInfo = resData?.skuList?.find(el => el.id === item.prdSkuId) || []
      setKitSku(skuInfo)
      setKitSpu(resData)
      setPackDtlList(item.packDtlList || [])
    } catch (error) {}
  }
  const closeKitDialog = (value: any) => {
    setOpenKitDialog(false)
  }
  // 确认信息
  const confirmInfo = (combinationInfoDetail: any, combinationPrice) => {
    // 更新packDtl
    updatePackDtl({
      data: {
        budgetDtlId: recordItem.id,
        packDtlList: combinationInfoDetail.filter(el => el.selectSkuId && el.checked),
      },
    }).then(res => {
      // message.success('更新成功')
      // getNewestPrice()
    })
  }
  return (
    <SDrawerOrModal
      open={open}
      title={'产品详情'}
      onCancel={onClose}
      antdProps={{ footer: [] }}
      width={1700}
    >
      <SLowcodeList config={config} {...extension} ref={listRef}></SLowcodeList>
      {/* 产品明细 */}
      {openKitDialog && (
        <KitDetailDialogV3
          kitSku={kitSku}
          setKitSku={setKitSku}
          productInfo={kitSpu}
          open={openKitDialog}
          closeDialog={closeKitDialog}
          confirmInfo={confirmInfo}
          combinationInfoList={combinationInfoList}
          packDtlList={packDtlList}
          // selectType={selectType}
          activityInfo={activityInfo}
          generalId={recordInfo.generalItemManageId}
          recordItem={recordItem}
          readOnly={true}
        />
      )}
      {previewObj.open && (
        <ProductDetailDrawer
          previewObj={previewObj}
          setPreviewObj={setPreviewObj}
        ></ProductDetailDrawer>
      )}
    </SDrawerOrModal>
  )
}
